import {
  configureStore,
  isFulfilled,
  isRejectedWithValue
} from '@reduxjs/toolkit'
import userSlice from '@/store/slices/userSlice'
import { toast } from 'react-toastify'
import {
  attachmentApi,
  attachmentReplacementCandidateApi,
  attachmentTypeApi,
  cityApi,
  companyApi,
  contractApi,
  employeeContractApi,
  employeeContractAttachmentApi,
  employeesApi,
  serviceAreaApi,
  serviceTypeApi,
  dashboardApi,
  officeApi,
  userApi,
  employeeRoleApi,
  assetApi,
  assetV2Api,
  userRoleApi,
  userInvitationApi,
  permissionApi,
  importApi,
  groupApi,
  referenceLibraryApi
} from './services'

/**
 * Log a warning and show a toast!
 */
export const rtkQueryNotification = (_api) => (next) => (action) => {
  if (isFulfilled(action)) {
    const successMessage =
      action?.payload?.data?.message || action?.payload?.message

    if (successMessage && !toast.isActive(successMessage)) {
      toast.success(successMessage)
    }

    next(action)
  }

  if (isRejectedWithValue(action)) {
    if (action?.payload?.status === 401) return next(action)
    if (action?.meta?.arg?.endpointName === 'sendAttachmentFile') return next(action)

    const errorMessages = action?.payload?.data?.errors || ['Ha ocurrido un error']
    errorMessages.forEach((errorMessage) => {
      if (!toast.isActive(errorMessage)) {
        toast.error(errorMessage, {
          toastId: errorMessage
        })
      }
    })
  }

  return next(action)
}

export const store = configureStore({
  reducer: {
    user: userSlice,
    [attachmentTypeApi.reducerPath]: attachmentTypeApi.reducer,
    [employeeContractApi.reducerPath]: employeeContractApi.reducer,
    [employeesApi.reducerPath]: employeesApi.reducer,
    [serviceAreaApi.reducerPath]: serviceAreaApi.reducer,
    [attachmentApi.reducerPath]: attachmentApi.reducer,
    [attachmentReplacementCandidateApi.reducerPath]:
      attachmentReplacementCandidateApi.reducer,
    [employeeContractAttachmentApi.reducerPath]:
      employeeContractAttachmentApi.reducer,
    [cityApi.reducerPath]: cityApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [serviceTypeApi.reducerPath]: serviceTypeApi.reducer,
    [contractApi.reducerPath]: contractApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [officeApi.reducerPath]: officeApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [employeeRoleApi.reducerPath]: employeeRoleApi.reducer,
    [assetApi.reducerPath]: assetApi.reducer,
    [assetV2Api.reducerPath]: assetV2Api.reducer,
    [userRoleApi.reducerPath]: userRoleApi.reducer,
    [userInvitationApi.reducerPath]: userInvitationApi.reducer,
    [permissionApi.reducerPath]: permissionApi.reducer,
    [importApi.reducerPath]: importApi.reducer,
    [groupApi.reducerPath]: groupApi.reducer,
    [referenceLibraryApi.reducerPath]: referenceLibraryApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      attachmentTypeApi.middleware,
      employeeContractApi.middleware,
      employeesApi.middleware,
      serviceAreaApi.middleware,
      attachmentApi.middleware,
      attachmentReplacementCandidateApi.middleware,
      employeeContractAttachmentApi.middleware,
      cityApi.middleware,
      companyApi.middleware,
      serviceTypeApi.middleware,
      contractApi.middleware,
      dashboardApi.middleware,
      officeApi.middleware,
      userApi.middleware,
      employeeRoleApi.middleware,
      assetApi.middleware,
      assetV2Api.middleware,
      userRoleApi.middleware,
      userInvitationApi.middleware,
      permissionApi.middleware,
      importApi.middleware,
      groupApi.middleware,
      referenceLibraryApi.middleware,
      rtkQueryNotification
    )
})
